/*
 * @Description: 实时定位驾驶舱 — A4「成员详情」本地 mock
 *   从 A2 成员 mock 派生，保证与列表/地图一致。
 */
import { MOCK_REALTIME_MEMBERS } from './members.mock'
import { MemberDetail } from '../types/cockpit.types'

/**
 * 按 userId 取 mock 成员详情。
 * @returns 命中返回详情；未命中返回 null
 */
export function getMockMemberDetail(userId: string): MemberDetail | null {
  const member = MOCK_REALTIME_MEMBERS.items.find((m) => m.userId === userId)
  if (!member) return null
  return {
    userId: member.userId,
    name: member.name,
    avatar: member.avatar,
    online: member.online,
    battery: member.battery,
    signal: member.signal,
    gpsStatus: member.gpsStatus,
    sleepState: 'active',
    location: member.location,
    address: member.address,
    locateTime: member.locateTime,
    imei: member.imei,
    deviceNo: member.deviceNo,
    usageDays: 30,
    bindAt: 1778256000000,
    lastOnlineAt: member.lastOnlineAt,
    bound: true
  }
}
